const firebaseConfig = {
    apiKey: "AIzaSyA9rdK0KnvmX1V6JFF9dG9H531LOLsxqlk",
    authDomain: "coin-rush-cd8c6.firebaseapp.com",
    projectId: "coin-rush-cd8c6",
    storageBucket: "coin-rush-cd8c6.appspot.com",
    messagingSenderId: "900913429062",
    appId: "1:900913429062:web:2b57ed4697d1cf536e6847"
  };
  export default firebaseConfig;